export const PAYMENT_FEE_SID_CONFIG = [
  103493, 103726, 102494, 103851, 102235, 103720, 188541, 104435, 158227, 178385, 101830, 195923, 201950, 206960,
  102786, 192990, 193217,
]
